/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_TitleInputs */

const en_admin_credits_title = /** @type {(inputs: Admin_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Admin_Credits_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_title = /** @type {((inputs?: Admin_Credits_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_title(inputs)
});
export { admin_credits_title as "admin.credits.title" }